import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ArrowUpIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon role="img" {...props} data-test-id="arrow-up-icon">
    <path d="M15.293 4.293a1 1 0 0 1 1.414 0l8.5 8.5a1 1 0 0 1-1.414 1.414L17 7.414V27a1 1 0 1 1-2 0V7.414l-6.793 6.793a1 1 0 0 1-1.414-1.414l8.5-8.5Z" />
  </BaseIcon>
);
